import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { prefetchMembershipAwarenessFormDataFromApi, useMembershipAwarenessFormDataFromApi } from './formData';

export type MembershipAwarenessFormPrefetchedContext = Readonly<{
	formData: Parameters<typeof useMembershipAwarenessFormDataFromApi>[0];
}>;

export type MembershipAwarenessFormCombinedState = ReturnType<typeof useMembershipAwarenessFormDataFromApi>;

export function useFormContext(
	prefetchedData?: MembershipAwarenessFormPrefetchedContext,
): MembershipAwarenessFormCombinedState {
	return useMembershipAwarenessFormDataFromApi(prefetchedData?.formData);
}

export async function prefetchFormContext(context: PrefetchContext): Promise<MembershipAwarenessFormPrefetchedContext> {
	const { session } = context;

	if (!session) throw new Error('Unexpected missing session');

	return { formData: await prefetchMembershipAwarenessFormDataFromApi(context) };
}

export type MembershipAwarenessFormPrefetchedDataProps = PrefetchedDataProps<MembershipAwarenessFormPrefetchedContext>;
